import dayjs from 'dayjs';

export const toTwoDecimals = (value: number) => (value / 100).toFixed(2);

export const formatDate = (date: string) => dayjs(date).format('DD.MM.YYYY');

export const formatDateTime = (date: string) =>
  dayjs(date).format('DD.MM.YYYY HH:mm:ss');
